import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import BlogPosts from "@/views/blog/Posts";
import BlogPost from "@/views/blog/Post";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Home from "./views/Home.vue";
import LeadsTasks from "./views/LeadsTasks";
import Page from "./views/Page.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";
import Project from "./views/Project.vue";
import Invoices from "@/views/Invoices.vue";
import Invoice from "@/views/Invoice.vue";
import OnLogin from "@/views/OnLogin.vue";
import Setup from "@/views/Setup.vue";
import Portfolio from "@/views/Portfolio.vue";
import Developer from "@/views/Developer.vue";
import axios from "axios";
import Workpage from "@/views/Workpage.vue";
import Review from "@/views/Review.vue";
import {eventBus, vm} from "@/main";

import Leads from "./views/Leads";
import Lead from './views/Lead';
import Funnel from './views/Funnel';
import Confirm from '@/views/Confirm.vue';
import Canban from "./views/Canban";
import Category from "./views/blog/Category";
import Invite from "./views/Invite";
import PortfolioCategory from "./views/site/PortfolioCategory";
import PortfolioWorks from "./views/site/PortfolioWorks";
import ServicePage    from "./views/site/ServicePage";
import ManageItems from "./views/shop/ManageItems.vue";
import ShopCategorys from "./views/shop/ShopCategorys.vue";
import Items  from "./views/shop/Items.vue";
import Item   from "./views/shop/Item.vue";
import Cart from "./views/shop/Cart.vue";
import Api from "./models/Api.js";
import RedirectTelegram from "./views/RedirectTelegram";
import UserModel from "./models/UserModel";
import store from "@/store";
import Notify from "./views/user/Notify";






Vue.use(Router);
(function() {
	'use strict';
	const { isNavigationFailure, NavigationFailureType } = Router;


	const original_push = Router.prototype.push;
	Router.prototype.push = function push(location) {
		original_push.call(this, location).catch(error => {
			if(!isNavigationFailure(error, NavigationFailureType.duplicated)) {
				//throw Error(error)
				console.log(error);
				//eventBus.$emit('refresh_fast_page');
			}else {
				eventBus.$emit('refresh_fast_page');
			}
		})
	};
	// ...ваш код...
})();





function getParameterByName(name, url = window.location.href) {
	name = name.replace(/[\[\]]/g, '\\$&');
	var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}



export default new Router({
	mode:"history",
	linkExactActiveClass: "active",
	fallback:false,
	routes: [

		{
			path: "/",
			name: "landing",
			components: {
				header: AppHeader,
				default: Landing,
				footer: AppFooter
			},
			meta: {
				need_login: false,

			},

		},

		{
			// /search/screens -> /search?q=screens
			path: '/redirect/',
			components: {

				default: RedirectTelegram,


			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/posts",
			name: "posts",
			components: {
				header: AppHeader,
				default: BlogPosts,
				footer: AppFooter
			},
			meta: {
				need_login: false,

			},
		},
		{
			path: "/post/:alias/:id/:rand?",
			name: "post",
			components: {
				header: AppHeader,
				default: BlogPost,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/canban/:rand?",
			name: "canban",
			components: {
				header: AppHeader,
				default: Canban,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/notify/:rand?",
			name: "notify",
			components: {
				header: AppHeader,
				default: Notify,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/leadtasks/:rand?",
			name: "leadtasks",
			components: {
				header: AppHeader,
				default: LeadsTasks,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/home/:rand?",
			name: "home",
			components: {
				header: AppHeader,
				default: Home,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/lead/:id/:rand?",
			name: "lead",
			components: {
				header: AppHeader,
				default: Lead,
				footer: AppFooter

			},
			meta: {
				need_login:true,

			},

		},
		{
			path: "/confirm/:id/:rand?",
			name: "confirm",
			components: {
				header: AppHeader,
				default: Confirm,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},


		},
		{
			path: "/invite/:id/:code/:rand?",
			name: "invite",
			components: {
				header: AppHeader,
				default: Invite,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},


		},
		{
			path: "/funnel/:id/:rand?",
			name: "funnel",
			components: {
				header: AppHeader,
				default: Funnel,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},

		},
		{
			path: "/leads/",
			name: "leads",
			components: {
				header: AppHeader,
				default: Leads,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/page/:id",
			name: "page",
			components: {
				header: AppHeader,
				default: Page,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},
		},
		{
			path: "/project/:id/:rand?",
			name: "project",
			components: {
				header: AppHeader,
				default: Project,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/portfolio",
			name: "portfolio",
			components: {
				header: AppHeader,
				default: Portfolio,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/shop/my",
			name: "shop_my",
			components: {
				header: AppHeader,
				default: ManageItems,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},

		{
			path: "/cart",
			name: "shop_cart",
			components: {
				header: AppHeader,
				default: Cart,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/shop/category/:id/",
			name: "shop_category_id",
			components: {
				header: AppHeader,
				default: Items,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/shop/item/:id/",
			name: "shop_item_id",
			components: {
				header: AppHeader,
				default: Item,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/shop",
			name: "shop_categorys",
			components: {
				header: AppHeader,
				default: ShopCategorys,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/invoices",
			name: "invoices",
			components: {
				header: AppHeader,
				default: Invoices,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/invoice/:id/:rand?",
			name: "invoice",
			components: {
				header: AppHeader,
				default: Invoice,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/developer/:username",
			name: "developer",
			components: {
				header: AppHeader,
				default: Developer,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/developer/:username/review",
			name: "reviewpage",
			components: {
				header: AppHeader,
				default: Review,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/developer/:username/:work_id",
			name: "workpage",
			components: {
				header: AppHeader,
				default: Workpage,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/setup",
			name: "setup",
			components: {
				header: AppHeader,
				default: Setup,
				footer: AppFooter

			},
			meta: {
				need_login: true,

			},
		},
		{
			path: "/works",
			name: "works_category",
			components: {
				header: AppHeader,
				default:PortfolioCategory,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/works/:category_id",
			name: "works_in_category",
			components: {
				header: AppHeader,
				default:PortfolioWorks,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/service/:service_id",
			name: "service_page",
			components: {
				header: AppHeader,
				default:ServicePage,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},

		},
		{
			path: "/:alias",
			name: "category_blog",
			components: {
				header: AppHeader,
				default:Category,
				footer: AppFooter

			},
			meta: {
				need_login: false,

			},

		},



	],


scrollBehavior(to, from, savedPosition) {
	// if(to.hash && to.hash.includes("tgWebAppData=")){
	// 	var urls=to.fullPath.split("#tgWebAppData=");
	// 	if(urls[0]){
	//
	// 		var new_route={};
	// 		new_route.path=urls[0];
	// 		new_route.query={t: new Date().getTime()};
	// 		if(to.query.rand_code){
	// 			new_route.query.rand_code=to.query.rand_code;
	// 		}
	// 		if(to.query.redirect_inner){
	// 			new_route.query.redirect_inner=to.query.redirect_inner;
	// 		}
	// 		vm.$router.push({path: urls[0]});;
	// 	}
	//
	// }

	if (to.hash && to.hash.includes("tgWebAppData=")==false) {
		// Required because our <RouterView> is wrapped in a <Transition>
		// So elements are mounted after a delay
		Api.tryScrollToAnchor(to.hash, 1000, 100);
	} else if (savedPosition) {
		return savedPosition;
	} else {
		return { x: 0, y: 0 };
	}
}
});
